import { useState } from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { GridDots } from 'tabler-icons-react';
import { currentUser } from 'Utils';
import { useDelayUnmount } from 'Hooks';
import { Button, Dropdown, DropdownUser, DropdownService } from 'Elements';
import Placeholder from 'assets/img/img-user-default.png';
import Logo from 'assets/img/icon-logo.svg';
import buttonStyles from 'partials/button.module.scss';
import styles from 'partials/dashboard/user-header.module.scss';

export const UserHeader = () => {
	const user = useSelector((state) => state.user);
	const [openDropdown, setOpenDropdown] = useState({
		service: false,
		user: false
	});
	const shouldRenderDropdownUser = useDelayUnmount(openDropdown.user, 350);
	const shouldRenderDropdownService = useDelayUnmount(
		openDropdown.service,
		350
	);

	const handleDropdown = (selected) => {
		setOpenDropdown((prev) => ({
			...prev,
			[selected]: !openDropdown[selected]
		}));
	};

	return (
		<header className={styles.header}>
			<div className={styles.logo}>
				<Link to="/">
					<img src={Logo} alt="shahrstory" className="logo" />
				</Link>
			</div>
			<div className={styles.icons}>
				<div className={styles.dropdown}>
					<Button
						onClick={() => handleDropdown('service')}
						className={styles.icon}>
						<GridDots />
					</Button>
					{shouldRenderDropdownService && (
						<Dropdown
							isOpen={openDropdown.service}
							onClickOut={() => handleDropdown('service')}>
							<DropdownService />
						</Dropdown>
					)}
				</div>
				<div className={styles.dropdown}>
					<div
						role="button"
						tabIndex="0"
						className={cx(styles.icon, buttonStyles.btn)}
						onKeyDown={() => handleDropdown('user')}
						onClick={() => handleDropdown('user')}>
						<img
							src={
								user.info?.avatar ??
								currentUser.getUser()?.avatar ??
								Placeholder
							}
							alt={user.info?.name}
							className={styles.dropdownImage}
						/>
					</div>
					{shouldRenderDropdownUser && (
						<Dropdown
							isOpen={openDropdown.user}
							onClickOut={() => handleDropdown('user')}>
							<DropdownUser
								onClose={() => handleDropdown('user')}
							/>
						</Dropdown>
					)}
				</div>
			</div>
		</header>
	);
};
